import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "submitLabel"]

  static values = {
    unlocked: Boolean,
    editLabel: String,
    submitLabel: String
  }

  connect() {
    this.syncState()
  }

  submitOrEnable() {
    if (!this.unlockedValue) {
      this.unlockedValue = true
      this.syncState()
      this.focusFirstField()
      return
    }

    this.element.requestSubmit()
  }

  unlockedValueChanged() {
    this.syncState()
  }

  syncState() {
    this.fieldTargets.forEach((field) => {
      field.disabled = !this.unlockedValue
    })

    if (this.hasSubmitLabelTarget) {
      this.submitLabelTarget.textContent = this.unlockedValue ? this.submitLabelText() : this.editLabelText()
    }
  }

  focusFirstField() {
    const firstField = this.fieldTargets[0]
    if (firstField) firstField.focus()
  }

  editLabelText() {
    return this.hasEditLabelValue ? this.editLabelValue : "Editar"
  }

  submitLabelText() {
    return this.hasSubmitLabelValue ? this.submitLabelValue : "Salvar alterações"
  }
}
